/* eslint-disable */
// Event Attachments card (iter-126j, slice 7 of EventDetail.jsx refactor).
// Renders the "Files" tab: upload button (admin), list of attachments
// with download + delete (admin), empty state.
import React from "react";
import { Download, FileText, Paperclip, Trash2, Upload } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { Button } from "../../components/ui/button";


export const EventAttachmentsCard = ({
  attachments,
  showAdminControls,
  uploadingFile,
  handleFileUpload,
  handleDownloadAttachment,
  handleDeleteAttachment,
  formatFileSize,
}) => (
  <Card className="glass-card">
    <CardHeader className="border-b border-white/5 pb-4">
      <div className="flex items-center justify-between">
        <CardTitle className="font-heading text-lg">Event Attachments</CardTitle>
        {showAdminControls && (
          <div className="relative">
            <input
              type="file"
              id="attachment-upload"
              className="hidden"
              onChange={handleFileUpload}
              disabled={uploadingFile}
              data-testid="attachment-upload-input"
            />
            <Button
              variant="outline"
              size="sm"
              onClick={() => document.getElementById('attachment-upload')?.click()}
              disabled={uploadingFile}
              className="border-primary/50 hover:bg-primary/10"
              data-testid="upload-attachment-btn"
            >
              {uploadingFile ? (
                <span className="animate-pulse">Uploading...</span>
              ) : (
                <>
                  <Upload className="w-4 h-4 mr-2" />
                  Upload File
                </>
              )}
            </Button>
          </div>
        )}
      </div>
      <p className="text-xs text-muted-foreground mt-2">
        Share sheet music, programmes, or other documents. Max 50MB per file.
      </p>
    </CardHeader>
    <CardContent className="p-0">
      {attachments && attachments.length > 0 ? (
        <div className="divide-y divide-white/5">
          {attachments.map((attachment) => (
            <div
              key={attachment.id}
              className="flex items-center justify-between p-4 hover:bg-secondary/30 transition-colors"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-primary/20 flex items-center justify-center">
                  <FileText className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <p className="font-medium">{attachment.original_filename}</p>
                  <p className="text-xs text-muted-foreground">
                    {formatFileSize(attachment.file_size)} • Uploaded by {attachment.uploaded_by_name}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => handleDownloadAttachment(attachment)}
                  className="hover:bg-primary/10"
                  data-testid={`download-attachment-${attachment.id}`}
                >
                  <Download className="w-4 h-4" />
                </Button>
                {showAdminControls && (
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => handleDeleteAttachment(attachment.id)}
                    className="hover:bg-red-500/10 text-red-400"
                    data-testid={`delete-attachment-${attachment.id}`}
                  >
                    <Trash2 className="w-4 h-4" />
                  </Button>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="p-8 text-center text-muted-foreground">
          <Paperclip className="w-12 h-12 mx-auto mb-4 opacity-50" />
          <p>No attachments yet</p>
          {showAdminControls && (
            <p className="text-sm mt-2">Upload sheet music, programmes, or other documents</p>
          )}
        </div>
      )}
    </CardContent>
  </Card>
);

export default EventAttachmentsCard;
